<template>
  <div class="post-card list-complete-item" :class="[{ isreject: post.status == 2 && post.isDraft == false }, { iswaiting: post.status == 0 && post.isDraft == false }, { isdraft: post.isDraft }]">
    <div class="post-header">
      <div class="profile-image">
        <img v-if="post.isAnnouncement || post.owner == null" :src="$imageus + currentOrganization.image + '?width=200&height=200&mode=cover'" style="cursor:unset !important;" />
        <img v-else-if="post.owner != null && !post.isAnnouncement" :src="$imageus + (post.owner.image == null ? host + '/static/img/500x500-user.png' : post.owner.image) + '?width=200&height=200&mode=cover'" />
      </div>
      <div class="user-details">
        <div class="username" v-if="!post.isAnnouncement">
          {{ post.owner == null ? currentEvent.title : post.owner.fullName }}
        </div>
        <div v-else class="username">
          {{ currentOrganization.title }}
        </div>
        <span class="time">{{ $moment(post.createDate).fromNow() }}</span>
      </div>
      <!-- <div class="post-type">
        <i class="social-post-type chat" v-if="post.topic != null"></i>
        <i class="social-post-type announcement" v-else-if="post.type == 0 && post.isAnnouncement == true"></i>
        <i class="social-post-type survey" v-else-if="post.type == 1"></i>
        <i class="social-post-type poll" v-else-if="post.type == 2"></i>
        <i class="social-post-type chat" v-else></i> 
      </div> -->
      <div class="isdraft" v-if="post.isDraft == true">
        <i class="fa fa-pen" @click="editSocialHubPost(post.id)"></i>
      </div>
      <el-tooltip :content="$t('components.socialhub.postCard.rejected')" placement="top">
        <div class="isrejected" v-if="post.status == 2 && post.isDraft == false">
          <i class="fa fa-times-circle"></i>
        </div>
      </el-tooltip>
      <el-tooltip :content="$t('components.socialhub.postCard.waiting')" placement="top">
        <div class="iswaiting" v-if="post.status == 0 && post.isDraft == false">
          <i class="fa fa-clock"></i>
        </div>
      </el-tooltip>

      <el-dropdown trigger="click" class="post-actions" @command="handlePostCommand">
        <span class="el-dropdown-link">
          <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <!-- <el-dropdown-item :command="'openRegistration#' + post.id" icon="el-icon-user-solid" v-if="post.isDraft == false">{{ $t("components.socialhub.postCard.openContactRegistration") }}</el-dropdown-item> -->

          <el-dropdown-item :command="'publishDraft#' + post.id" icon="el-icon-s-promotion" v-if="post.isDraft == true">{{ $t("components.socialhub.postCard.publishDraft") }}</el-dropdown-item>

          <el-dropdown-item :command="'approvePost#' + post.id" icon="el-icon-check" v-if="post.status != 1 && post.isDraft == false">{{ $t("components.socialhub.postCard.confirmShipment") }}</el-dropdown-item>
          <el-dropdown-item :command="'rejectPost#' + post.id" icon="el-icon-error" v-if="post.status != 2 && post.status != 1 && post.isDraft == false">{{ $t("components.socialhub.postCard.rejectPost") }}</el-dropdown-item>

          <!-- <el-dropdown-item divided :command="'screenCastPoll#' + post.id" icon="el-icon-s-platform" v-if="post.type == 1 && post.hasScreencast == false && post.isDraft == false" disabled>{{ $t("components.socialhub.postCard.reflectVoting") }}</el-dropdown-item>
          <el-dropdown-item divided :command="'stopScreenCastPoll#' + post.id" icon="el-icon-s-platform" v-if="post.type == 1 && post.hasScreencast == true && post.isDraft == false">{{ $t("components.socialhub.postCard.stopvoting") }}</el-dropdown-item> -->

          <el-dropdown-item divided :command="'downloadData#' + post.id" icon="el-icon-s-data" v-if="(post.type == 1 || post.type == 2)">{{ $t("components.socialhub.postCard.downloadResult") }}</el-dropdown-item>

          <el-dropdown-item :command="'changePollStatus#' + post.id" icon="el-icon-s-release" v-if="post.type == 1 && post.isDraft == false && post.isOver == false">{{ $t("components.socialhub.postCard.endVoting") }}</el-dropdown-item>
          <el-dropdown-item divided :command="'changeSurveyStatus#' + post.id" icon="el-icon-s-release" v-if="post.type == 2 && post.isDraft == false && post.isOver == false">{{ $t("components.socialhub.postCard.endPoll") }}</el-dropdown-item>
          <el-dropdown-item :command="'changePollStatus#' + post.id" icon="fas fa-clipboard-check" v-if="post.type == 1 && post.isOver == true && post.isDraft == false">{{ $t("components.socialhub.postCard.restartVoting") }}</el-dropdown-item>
          <el-dropdown-item divided :command="'changeSurveyStatus#' + post.id" icon="fas fa-clipboard-check" v-if="post.type == 2 && post.isOver == true && post.isDraft == false">{{ $t("components.socialhub.postCard.restartPoll") }}</el-dropdown-item>

          <!-- <el-dropdown-item divided :command="'sendNotification#' + post.id" icon="el-icon-message-solid" v-if="(post.type == 1 || post.type == 2) && post.isOver == false && post.isDraft == false">{{ $t("components.socialhub.postCard.sendReminderNotification") }}</el-dropdown-item> -->

          <el-dropdown-item :command="'editPost#' + post.id" icon="fas fa-pen">{{ $t("components.socialhub.postCard.editPost") }}</el-dropdown-item>
          <el-dropdown-item :command="'deletePost#' + post.id" icon="fas fa-trash">{{ $t("components.socialhub.postCard.deletePost") }}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <div class="topic-area" v-if="post.topic != null" :style="{ 'background-color': post.topic.color }">
      <span>{{ $t("components.socialhub.postCard.bigSubject") }} : {{ post.topic.title }}</span>
    </div>
    <div class="post-text" v-if="post.postText != null">
      <div class="text" :class="{ 'line-clamp': post.postText.length > 200 }" v-html="parseUrl(post.postText, post)"></div>
      <span class="read-more" v-if="post.postText.length > 200">{{ $t("components.socialhub.postCard.continueReading") }}</span>
    </div>
    <div class="poll-area" v-if="post.type == 1 && post.questions.length > 0">
      <div class="poll-title">
        {{ pollQuestion().title }}
      </div>
      <div class="poll-answer-list">
        <div class="poll-answer-wrapper" :class="(option.id == pollQuestion().answer ? 'selected' : '') + ' ' + (post.isJoined ? 'isApplied' : '')" v-for="(option, index) in pollQuestion().options" :key="option.id + '-pollOption-' + post.id + '--' + index" @click="post.isJoined != true && post.isOver == false ? (pollQuestion().answer = option.id) : null">
          <div class="answer-item">
            <span>{{ option.title }}</span>
            <span class="percentage">{{ "% " + option.percentage }}</span>
            <div class="polls-bar" :style="'transition: 1s; width: ' + option.percentage + '%;'"></div>
            <span v-if="option.id == pollQuestion().answer && post.isJoined != true"><i class="fas fa-check"></i></span>
          </div>
        </div>
        <div class="poll-is-over" v-if="post.isOver">
          {{ $t("components.socialhub.postCard.votingEnded") }}
        </div>
        <div class="poll-attendings">{{ attendingsPoll() }} {{ $t("components.socialhub.postCard.joinedPeopleVoting") }}</div>
      </div>
    </div>
    <div class="survey-area" v-if="post.type == 2">
      <div class="survey-title">
        {{ post.title }}
      </div>
      <div class="survey-joined-area" v-if="!surveyOpened">
        <el-button :type="post.isJoined ? 'success' : 'primary'" :disabled="post.isJoined" @click="openSurvey" :loading="loading == 'survey-opened'">{{ post.isJoined ? $t("components.socialhub.postCard.youJoinedPoll") : $t("components.socialhub.postCard.join") }}</el-button>
        <div class="estimated-question">{{ $t("components.socialhub.postCard.surveyQuestionNumber", [post.estimatedQuestionCount]) }}</div>
      </div>
      <div class="survey-questions-area" v-if="surveyOpened">
        <!-- Single line text -->
        <transition name="el-fade-in" mode="out-in">
          <RecursiveQuestionBuilder :registrationFormId="post.id" :question="availableQuestions[currentQuestionIndex]" :availableQuestions="availableQuestions" :currentIndex="currentQuestionIndex" :allQuestions="currentQuestionList" :key="availableQuestions[currentQuestionIndex].id" />
        </transition>
        <div class="footer">
          <div class="survey-index">{{ currentQuestionIndex + 1 }}/{{ availableQuestions.length }}</div>
          <div class="next-index">
            <el-button type="primary" circle size="mini" icon="social-chevron left" :disabled="currentQuestionIndex == 0" :loading="loading == 'surveyLoading'" @click="prevQuestion"></el-button>
            <el-button type="primary" circle size="mini" icon="social-chevron" :loading="loading == 'surveyLoading'" @click="nextQuestion"></el-button>
          </div>
        </div>
      </div>
    </div>
    <div class="post-image" v-if="post.image != null">
      <img :src="post.image" />
    </div>
    <div class="post-attending" v-if="post.attendings > 0 && post.type != 1">{{ post.attendings }} {{ $t("components.socialhub.postCard.peopleTalkingAboutIt") }}</div>
    <div class="post-buttons-bar" v-if="post.status == 1">
      <i class="comment-area-icon" @click="openComment"></i>
      <div class="comment-count" v-if="post.comments > 0" @click="openComment">{{ post.comments }} {{ $t("components.socialhub.postCard.comment") }}</div>
      <div
        class="comment"
        @click="
          newComment = !newComment;
          comment.commentText = null;
        "
        v-else
      >
        {{ $t("components.socialhub.postCard.doComment") }}
      </div>
      <div
        class="comment-reply"
        v-if="post.comments > 0"
        @click="
          newComment = !newComment;
          comment.commentText = null;
        "
        :style="{ color: newComment ? '#FF6565' : '#292F3B' }"
      >
        {{ newComment ? $t("components.socialhub.postCard.cancel") : $t("components.socialhub.postCard.reply") }}
      </div>

      <div class="liked-area" @click="toggleLike">
        <i class="el-icon-loading" v-if="loading == 'toggleLikePost'"></i>
        <i class="hearth-icon" v-else :class="{ active: post.isLiked }"></i>
      </div>
    </div>
    <transition name="el-zoom-in-top" mode="out-in">
      <div class="send-comment" v-if="newComment" :key="'new-comment-area-' + post.id + '-key-' + newComment" @keyup.enter.exact="postComment()">
        <div v-if="isCommentMentionVisible" v-swiper:mySwiper="swiperOption" class="mention-panel">
          <!-- <div v-for="(user, index) in users" :key="index" @click.stop="tagUser(user, post)" class="mention-item">
            <div :style="user.image == null ? 'background-color: f1f1f1;' : 'background-image: url(' + $imageus + user.image + '?width=200&height=200&mode=cover&background=ffffff'" class="user-image"></div>
            <p v-if="user.type == 2">{{ user.title }}</p>
            <p else>{{ user.fullName }}</p>
          </div> -->
          <div class="swiper-wrapper">
            <div v-for="(user, index) in users" :key="index" @click.stop="tagUser(user, post)" class="mention-item swiper-slide">
              <div :style="user.image == null ? 'background-color: f1f1f1;' : 'background-image: url(' + $imageus + user.image + '?width=200&height=200&mode=cover&background=ffffff'" class="user-image"></div>
              <p v-if="user.type == 2">{{ user.title }}</p>
              <p else>{{ user.fullName }}</p>
            </div>
          </div>
        </div>
        <el-input v-model="comment.commentText" resize="auto" class="comment-input" @input="commentMention(post)">
          <template slot="suffix">
            <i class="el-input__icon fas " :class="loading == 'postCommentLoading' ? 'el-icon-loading' : 'fa-paper-plane'" @click="postComment"></i>
          </template>
        </el-input>
      </div>
    </transition>
    <div class="post-comment-area" v-if="commentOpen">
      <transition-group name="list-complete" tag="div">
        <Comment v-for="comment in post.postComments" :key="comment.id + '-post-parent-comment-'" @deleteMe="deleteComment" :comment="comment" />
      </transition-group>
      <div class="load-comment-btn" v-if="loadCommentBtn">
        <el-button type="primary" round size="mini" :loading="loading == 'loadComments'" @click="loadComment">{{ $t("components.socialhub.postCard.loadMore") }}</el-button>
      </div>
      <div class="load-comment-btn" v-else>
        <el-button size="mini" type="success" round @click="commentOpen = false">{{ $t("components.socialhub.postCard.hideComment") }}</el-button>
      </div>
    </div>
    <div class="post-liked-users-area" v-if="post.likes > 0">
      <span v-if="post.isLiked && post.likes - 1 == 0">{{ $t("components.socialhub.postCard.youLikedIt") }}</span>
      <span v-else-if="post.isLiked && post.likes - 1 > 0 && post.likes - 1 <= 3">{{ $t("components.socialhub.postCard.youAndPeopleLiked", [post.likes - 1]) }}</span>
      <span v-else>{{ post.likes }} {{ $t("components.socialhub.postCard.peopleLiked") }}</span>
      <div class="liked-users" v-if="post.latesLikes > 0">
        <img v-for="user in post.latestLikes" :key="user.id + '-latest-likes-user'" :src="user.image != null ? user.image : host + '/static/500x500-user.png'" :alt="user.fullName" />
      </div>
    </div>
  </div>
</template>

<script>
import RecursiveQuestionBuilder from "../participants/Questions.vue";
import Comment from "./NewComment.vue";
import { dragscroll } from "vue-dragscroll";

export default {
  directives: {
    dragscroll
  },
  components: {
    RecursiveQuestionBuilder,
    Comment
  },
  props: ["post"],
  data() {
    return {
      swiperOption: {
        slidesPerView: "auto",
        autoWidth: true,
        spaceBetween: 20
      },
      host: location.host == "localhost:8081" ? "https://app.holacon.com/" : "https://" + location.host,
      newComment: false,
      isCommentMentionVisible: false,
      users: [],
      searchTerm: null,
      comment: {
        id: null,
        postId: this.post.id,
        commentText: null,
        parentId: null,
        mentions: []
      },
      timeout: null,
      loading: false,
      commentOpen: false,
      loadCommentBtn: true,
      availableQuestions: [],
      currentQuestionList: [],
      surveyOpened: false,
      currentQuestionIndex: 0,
      firstOpen: false,
      skip: 0
    };
  },
  methods: {
    deleteComment(commentId) {
      // this.$message.success("deleteCommend", commentId);
      var fIndex = this.post.postComments.findIndex(x => x.id == commentId);
      if (fIndex != -1) {
        this.post.postComments.splice(fIndex, 1);
      }
    },
    async openSurvey() {
      if (!this.post.isJoined) {
        this.loading = "survey-opened";
        if (this.timeout != null) clearTimeout(this.timeout);
        this.timeout = setTimeout(async () => {
          var res = await this.$store.dispatch("getQuestionsObject", { id: this.post.id, type: 2 });
          if (!res.data.alert.hasError) {
            this.currentQuestionList = res.data.data.items;
            this.availableQuestions = res.data.data.items.filter(x => x.parentAnswerId == null && x.parentQuestionId == null);
            this.surveyOpened = true;
          } else {
            this.surveyOpened = false;
          }
          this.loading = false;
        }, 500);
      }
    },
    prevQuestion() {
      if (this.currentQuestionIndex == 0) {
        return;
      } else {
        this.currentQuestionIndex -= 1;
      }
    },
    nextQuestion() {
      if (this.availableQuestions.length == this.currentQuestionIndex + 1) {
        this.currentQuestionIndex = 0;
        this.surveyOpened = false;
        return;
      }
      this.currentQuestionIndex += 1;
    },
    attendingsPoll() {
      var count = 0;
      this.post.questions[0].options.forEach(x => {
        count += x.count;
      });
      return count;
    },
    pollQuestion() {
      return this.post.questions[0];
    },
    commentMention(post) {
      if (this.comment.commentText != "" && this.comment.commentText != null) {
        this.comment.commentText.split(" ").forEach(item => {
          if (item.startsWith("@")) {
            this.users = [];
            this.isCommentMentionVisible = true;
            this.searchTerm = item.replace("@", "");
            this.timeout = setTimeout(async () => {
              var res = await this.$store.dispatch("socialHubMentionSearch", this.searchTerm);
              this.users = res.data.data.items;
            }, 500);
          } else {
            this.isCommentMentionVisible = false;
            this.searchTerm = "";
          }
        });
      }
    },
    tagUser(user, post) {
      this.isCommentMentionVisible = false;
      this.comment.commentText = this.comment.commentText.replace("@" + this.searchTerm, user.fullName + " ");
      this.comment.mentions.push(user);
      this.users = [];
      this.searchTerm = "";
      this.users = [];
    },
    async openComment() {
      if (!this.firstOpen) {
        var res = await this.$store.dispatch("socialHubListComments", {
          skip: this.post.postComments.length,
          take: 5,
          parentId: null,
          postId: this.post.id
        });
        var comments = res.data.data.items;
        comments = comments.map(x => {
          return {
            ...x,
            subComments: []
          };
        });
        if (comments.length > 0) {
          this.post.postComments.push(...comments.reverse());
        }
        if (res.data.data.items.length == 5) {
          this.skip += 5;
          this.loadCommentBtn = true;
        } else {
          this.loadCommentBtn = false;
        }
        this.firstOpen = true;
      }
      this.commentOpen = !this.commentOpen;
    },
    async loadComment() {
      this.loading = "loadComments";
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var res = await this.$store.dispatch("socialHubListComments", {
          skip: this.post.postComments.length,
          take: 5,
          parentId: null,
          postId: this.post.id
        });
        var comments = res.data.data.items;
        comments = comments.map(x => {
          return {
            ...x,
            subComments: []
          };
        });
        if (comments.length > 0) {
          this.post.postComments.push(...comments.reverse());
        }
        if (comments.length == 5) {
          this.skip += 5;
          this.loadCommentBtn = true;
        } else {
          this.loadCommentBtn = false;
        }
        this.loading = false;
      }, 500);
    },
    async postComment() {
      this.loading = "postCommentLoading";
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var commentTitle = this.comment.commentText;
        if (commentTitle != null && commentTitle != "") {
          this.comment.mentions.forEach(user => {
            commentTitle = commentTitle.replace(user.fullName, "%" + user.id + "%");
          });
          var res = await this.$store.dispatch("socialHubAddUpdateComment", {
            id: null,
            parentId: null,
            postId: this.post.id,
            commentText: commentTitle != "" ? commentTitle : this.comment.commentText,
            mentions: this.comment.mentions
          });
          if (res.data.hasError == true) {
            this.$message.error(res.data.message);
          } else {
            this.comment.commentText = null;
            this.users = [];
          }
          this.comment.mentions = [];
          this.newComment = false;
        } else {
          this.$message.error(this.$t("components.socialhub.postCard.pleaseWrite"));
        }

        this.loading = false;
      }, 500);
    },
    async toggleLike() {
      this.loading = "toggleLikePost";
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var dammyLike = !this.post.isLiked;
        var res = await this.$store.dispatch("socialHubToggleLike", { id: this.post.id, isLiked: dammyLike });
        if (!res.data.alert.hasError) {
          this.post.isLiked = dammyLike;
          this.post.likes = res.data.data.likes;
          this.post.likeCount = res.data.data.likes;
        }
        this.loading = false;
      }, 500);
    },
    parseUrl(text, post) {
      var urlRegex = /(https?:\/\/[^\s]+)/g;
      var usernameRegex = /\%(.*?)\%/g;
      if (text == null) return;
      text = text.replace(urlRegex, function(url) {
        return '<a href="' + url + '" target="_blank">' + url + "</a>";
      });
      post.mentions.forEach(user => {
        if (text.includes("%" + user.id + "%")) {
          text = text.replace("%" + user.id + "%", '<a href="javascript:;" user-id="' + user.id + '" class="open-user">@' + user.fullName + "</a>");
        }
      });
      return text;
    },
    async handlePostCommand(command) {
      var comm = command.split("#")[0];
      var uid = command.split("#")[1];
      switch (comm) {
        case "approvePost":
          var res = await this.$store.dispatch("socialHubChangeStatus", { id: uid, status: 1 });
          if (!res.data.alert.hasError) {
            this.post.status = 1;
          }
          break;
        case "rejectPost":
          // this.$message('click on item ' + 'rejectPost' + uid);
          var res = await this.$store.dispatch("socialHubChangeStatus", { id: uid, status: 2 });
          if (!res.data.alert.hasError) {
            this.post.status = 2;
          }
          break;
        case "publishDraft":
          var dummyPost = JSON.parse(JSON.stringify(this.post));
          dummyPost.isDraft = false;
          var res = await this.$store.dispatch("socialHubAddOrUpdate", dummyPost);
          if (!res.data.alert.hasError) {
            this.post.isDraft = false;
          }
          break;
        case "screenCastPoll":
          var res = await this.$store.dispatch("socialHubToggleHasScreencast", uid);
          if (!res.data.alert.hasError) {
            this.post = res.data.data.item;
          }
          break;
        case "stopScreenCastPoll":
          var res = await this.$store.dispatch("socialHubToggleHasScreencast", uid);
          if (!res.data.alert.hasError) {
            this.post = res.data.data.item;
          }
          break;
        case "changePollStatus":
          var res = await this.$store.dispatch("socialHubToggleIsOver", this.post.id);
          if (!res.data.alert.hasError) {
            this.post.isOver = res.data.data.isOver;
          }
          break;
        case "changeSurveyStatus":
          var res = await this.$store.dispatch("socialHubToggleIsOver", this.post.id);
          if (!res.data.alert.hasError) {
            this.post.isOver = res.data.data.isOver;
          }
          break;
        case "sendNotification":
          this.$message("click on item " + "sendNotification" + uid);
          break;
        case "downloadData":
          if (this.post.type == 0) {
            return;
          }
          var type = null;
          if (this.post.type == 1) {
            type = 9;
          } else if (this.post.type == 2) {
            type = 5;
          }
          this.exportXlsx(type, uid, null);
          break;
        case "editPost":
          this.editSocialHubPost(uid);
          break;
        case "openRegistration":
          this.$message("click on item " + "openRegistration" + uid);
          break;
        case "deletePost":
          if (this.timeout != null) clearTimeout(this.timeout);
          this.showComments = false;
          var res = await this.$store.dispatch("socialHubDelete", { id: uid });
          if (!res.data.alert.hasError) {
            this.$store.commit("deleteSocialPost", uid);
          }
          break;
        case "editComment":
          this.$message("click on item " + "editComment" + uid);
          break;
        case "deleteComment":
          this.$message("click on item " + "deletePost" + uid);
          break;
        case "editSubComment":
          this.$message("click on item " + "deletePost" + uid);
          break;
        case "deleteSubComment":
          this.$message("click on item " + "deletePost" + uid);
          break;
      }
    }
  },
  computed: {
    currentEvent() {
      return this.$store.getters.currentEvent;
    },
    currentOrganization() {
      return this.$store.getters.getCurrentOrganization;
    }
  }
};
</script>

<style lang="less" scoped>
.post-card {
  background-color: #fff;
  // box-shadow: 0 2px 10px rgb(41 47 59 / 10%);
  border-radius: 16px;
  &.iswaiting {
    background-color: rgba(246, 150, 86, 0.6);
    color: white !important;
    span {
      color: white !important;
    }
    .post-text {
      color: white !important;
    }
    .post-actions {
      margin-left: unset !important;
    }
  }
  &.isreject {
    background: #ff6565;
    background-color: rgba(255, 101, 101, 0.6);

    color: white !important;
    span {
      color: white !important;
    }
    .post-text {
      color: white !important;
    }
    .post-actions {
      margin-left: unset !important;
    }
  }
  &.isdraft {
    background: #505763;
    i.fa.fa-pen {
      cursor: pointer;
    }
    color: white !important;
    span {
      color: white !important;
    }
    .post-text {
      color: white !important;
    }
    .post-actions {
      margin-left: unset !important;
    }

    a.open-user {
      color: #46adc6 !important;
    }

    .read-more {
      color: #46adc6 !important;
    }
  }
  .isdraft,
  .iswaiting,
  .isrejected {
    margin-left: auto !important;
  }
  padding: 10px;
  width: 100%;
  box-shadow: 0px 2px 10px rgba(41, 47, 59, 0.2);
  display: flex;
  flex-direction: column;
  gap: 1rem;
  & > .post-header {
    display: flex;
    align-items: center;
    width: 100%;
    gap: 10px;
    .profile-image {
      img {
        width: 48px;
        height: 48px;
        object-fit: cover;
        border: 2px solid #e8ebef;
        border-radius: 50%;
      }
    }

    .user-details {
      display: flex;
      flex-direction: column;
      .username {
        font-weight: 600;
        font-size: 14px;
        line-height: 24px;
        letter-spacing: 0.2px;
      }
      & > span {
        font-weight: 400;
        font-size: 12px;
        line-height: 18px;
        letter-spacing: 0.2px;
        color: #8c929c;
      }
    }
    .post-actions {
      color: #8c929c;
      font-size: 12px;
      text-align: end;
      justify-self: flex-end;
      cursor: pointer;
      margin-left: auto;
      margin-right: 1rem;
      span {
        i {
          font-size: 16px;
        }
      }
    }
    .post-type {
      margin-left: auto;
    }
  }
  .post-image {
    img {
      border-radius: 12px;
      max-height: 338px;
      width: 100%;
      object-fit: cover;
    }
  }
  .topic-area {
    min-height: 48px;
    padding: 12px;
    border-radius: 12px;
    color: white;
    font-weight: bold;
    font-size: 16px;
    line-height: 24px;

    letter-spacing: 0.2px;
  }
  .post-attending {
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    color: #8c929c;
    letter-spacing: 0.2px;
  }
  .post-text {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #505763;
    a.open-user {
      color: #268ea6;
      font-weight: 400;
      &:hover {
        text-decoration: none;
      }
    }
    .read-more {
      cursor: pointer;
      letter-spacing: 0.2px;
      text-decoration-line: underline;
      font-weight: 700;
      font-size: 14px;
      line-height: 20px;
      color: #268ea6;
    }
  }
  .post-liked-users-area {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    gap: 8px;
    & > span {
      font-weight: 400;
      font-size: 12px;
      line-height: 20px;
      letter-spacing: 0.2px;
      color: #505763;
    }
    .liked-users {
      flex-shrink: 0;
      display: flex;
      flex-direction: row;
      align-items: center;
      img {
        width: 24px;
        height: 24px;
        flex-shrink: 0;
        border: 1.5px solid white;
        border-radius: 50%;
        object-fit: cover;
        margin-left: -8px;
        &:first-child {
          margin-left: 0px;
        }
      }
    }
  }
  .post-buttons-bar {
    display: flex;
    align-items: center;
    .comment-count,
    .comment {
      font-weight: 400;
      font-size: 14px;
      letter-spacing: 0.2px;
      cursor: pointer;
      color: #292f3b;
      margin-left: 8.5px;
      height: 20px;
      text-align: center;
    }
    .comment-reply {
      font-weight: 700;
      font-size: 14px;
      line-height: 20px;
      text-decoration-line: underline;
      color: #292f3b;
      margin-left: 4px;
      cursor: pointer;
    }
    .liked-area {
      margin-left: auto;
      display: flex;
      align-items: center;
      cursor: pointer;

      gap: 8px;
      & > span {
        transition: all 0.2s;
        font-weight: 400;
        font-size: 14px;
        display: flex;
        align-items: center;
      }
      & > i {
        cursor: pointer;
        font-size: 14px;
        text-align: center;
        font-weight: bold;
        &.active {
          color: red;
        }
      }
    }
  }
  .send-comment {
    position: relative;
    .mention-panel {
      // swiper container
      position: absolute;
      top: calc(~"-100% - 1.5rem");
      left: 0;
      display: flex;
      gap: 10px;
      background: #ffffff;
      box-shadow: 0px 2px 8px rgba(41, 47, 59, 0.24);
      border-radius: 12px;
      padding: 10px;
      height: 60px;
      width: 100%;
      overflow-y: hidden;
      overflow-x: hidden;
      .mention-item {
        flex-shrink: 0;
        cursor: pointer;
        display: flex;
        gap: 8px;
        width: max-content;
        align-items: center;
        .user-image {
          border: 2px solid #e8ebef;
          width: 38px;
          height: 38px;
          border-radius: 50%;
          background-size: cover;
          flex-shrink: 0;
        }
        p {
          margin-bottom: 0;
          font-weight: 700;
          font-size: 14px;
          line-height: 20px;
          color: #292f3b;
          flex-shrink: 0;
        }
      }
    }
  }
  .post-comment-area {
    .load-comment-btn {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .poll-area {
    display: flex;
    flex-direction: column;
    gap: 1rem;

    .poll-title {
      width: 100%;
      font-weight: 600;
      font-size: 16px;
      line-height: 24px;
      text-align: center;
    }
    .poll-answer-list {
      display: flex;
      flex-direction: column;
      gap: 5px;
      .poll-answer-wrapper {
        border: 2px solid #c8cdd3;
        border-radius: 12px;
        cursor: pointer;
        user-select: none;
        padding: 4px;
        &.selected {
          border: 2px solid #268ea6;
          .answer-item {
            .polls-bar {
              background-color: #c1e8f1;
            }
          }
        }
        i {
          color: #268ea6;
        }
        .answer-item {
          .percentage {
            flex-shrink: 0;
          }
          padding: 8px 16px;
          font-weight: 400;
          display: flex;
          justify-content: space-between;
          align-items: center;
          border-radius: 8px;
          font-size: 16px;
          line-height: 24px;
          position: relative;
          span {
            z-index: 2;
          }
          .polls-bar {
            position: absolute;
            background-color: #e8ebef;
            border-radius: 8px;
            left: 0;
            top: 0;
            height: 100%;
          }
        }
      }
      .poll-is-over {
        font-weight: 400;
        font-size: 14px;
        line-height: 18px;
      }
      .poll-attendings {
        font-weight: 400;
        font-size: 14px;
        line-height: 18px;
        color: #8c929c;
      }
    }

    .poll-button {
      width: 100%;
      padding: 0px 16px;
      .el-button {
        width: 100% !important;
      }
    }
  }
  .survey-area {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    .survey-title {
      font-weight: 600;
      font-size: 16px;
      line-height: 24px;
      text-align: center;
    }
    .survey-joined-area {
      padding: 1rem;
      border: 2px solid #c8cdd3;
      border-radius: 16px;
      display: flex;
      flex-direction: column;
      gap: 10px;
      .el-button {
        width: 100% !important;
        border-radius: 12px;
        font-weight: 600;
        font-size: 16px;
        line-height: 24px;
      }
      .estimated-question {
        font-weight: 400;
        font-size: 12px;
        line-height: 18px;
        color: #8c929c;
        text-align: center;
      }
    }
    .survey-questions-area {
      padding: 20px 10px 10px 10px;
      border: 2px solid #c8cdd3;
      border-radius: 16px;
      .survey-question {
        .sub-title {
          font-weight: 400;
          font-size: 14px;
          line-height: 20px;
          color: #505763;
          text-align: center;
          margin-bottom: 1rem;
          .el-input {
            width: 100%;
          }
        }
      }
      .footer {
        margin-top: 1rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .survey-index {
          font-weight: 700;
          font-size: 14px;
          line-height: 20px;
          color: #8c929c;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/socialhub/NewPostCard.vue